import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  IonApp,
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuToggle,
  IonNote,
  IonRouterOutlet,
  IonSplitPane,
  alertController,
} from '@ionic/vue';
import {Capacitor} from '@capacitor/core';
import { ref, onMounted } from 'vue';
import {
  archiveOutline,
  archiveSharp,
  bookmarkOutline,
  bookmarkSharp,
  heartOutline,
  heartSharp,
  mailOutline,
  mailSharp,
  paperPlaneOutline,
  paperPlaneSharp,
  trashOutline,
  trashSharp,
  warningOutline,
  warningSharp,
} from 'ionicons/icons';
import { useStore } from 'vuex';
import axios from 'axios';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();

    onMounted(async () => {
      try {
        const platform = await Capacitor.getPlatform();
        const response = await axios.get('/app-version', {
          params: {
            platform: platform
          }
        });
        // Assumo che il json ritorni un oggetto con proprietà version, es: { version: '1.1.6' }
        const backendVersion = response.data.app_version;
        const appStoreLink = response.data.store_link;
        const currentVersion = store.getters.getAppCurrentVersion;
        console.log("currentVersion: ", currentVersion);
        console.log("backendVersion: ", backendVersion);
        console.log("appStoreLink: ", appStoreLink);

        if (backendVersion && backendVersion !== currentVersion) {
          const alert = await alertController.create({
            header: 'Aggiornamento disponibile',
            message: `È disponibile un nuovo aggiornamento dell'app. Ti invitiamo a scaricare il nuovo aggiornamento.`,
            buttons: [
              {
                text: 'Aggiorna',
                handler: () => {
                  window.open(appStoreLink, '_system');
                }
              },
            ],
            backdropDismiss: false
          });

          await alert.present();
        }
      } catch (error) {
        console.error('Impossibile verificare la versione dell\'app', error);
      }
    });

    const selectedIndex = ref(0);
    const appPages = [
      {
        title: 'Inbox',
        url: '/folder/Inbox',
        iosIcon: mailOutline,
        mdIcon: mailSharp,
      },
      {
        title: 'Outbox',
        url: '/folder/Outbox',
        iosIcon: paperPlaneOutline,
        mdIcon: paperPlaneSharp,
      },
      {
        title: 'Favorites',
        url: '/folder/Favorites',
        iosIcon: heartOutline,
        mdIcon: heartSharp,
      },
      {
        title: 'Archived',
        url: '/folder/Archived',
        iosIcon: archiveOutline,
        mdIcon: archiveSharp,
      },
      {
        title: 'Trash',
        url: '/folder/Trash',
        iosIcon: trashOutline,
        mdIcon: trashSharp,
      },
      {
        title: 'Spam',
        url: '/folder/Spam',
        iosIcon: warningOutline,
        mdIcon: warningSharp,
      },
    ];
const labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];

const path = window.location.pathname.split('folder/')[1];
if (path !== undefined) {
  selectedIndex.value = appPages.findIndex((page) => page.title.toLowerCase() === path.toLowerCase());
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRouterOutlet))
    ]),
    _: 1
  }))
}
}

})